module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"no_orders_to_review":"No orders available for review.","confirm_cancel_review":"Are you sure you want to cancel? If you cancel now, all entered content will be deleted."}}')
  delete Component.options._Ctor
}
